import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

// 접속시간 기준 담당시간의 시간 범위 수정
export const convertToWorkTimeCheckList = workTimeList => {
    return workTimeList.map(item => {
        const { startDate, endDate } = item;
        let start = moment(startDate * 1000);
        let end = moment(endDate * 1000);
        let checked = item.checked ?? false;
        // 현재 시간 범위에 있을 경우 종료시간 = 현재시간
        if (moment().isBetween(start, end)) {
            checked = true;
            end = moment();
        }
        // 시작 시간이 현재 시간 보다 큰 경우 시작,종료 D-1
        if (moment().unix() < start.unix()) {
            start = start.subtract(1, 'day');
            end = end.subtract(1, 'day');
        }
        return {
            ...item,
            startDate: start.unix(),
            endDate: end.unix(),
            checked,
        };
    });
};

export const initialState = {
    vitalSignsList: {},
    workTimeList: {
        origin: [],
        current: [],
    },
    isDetail: false,
    targetNum: null,
};

const { actions, reducer } = createSlice({
    name: 'vitalSignsMonitoring',
    initialState,
    reducers: {
        storeVitalSignList: (state, action) => {
            const data = action.payload;
            if (!data) {
                return;
            }

            state.vitalSignsList = (function loop(entryValues) {
                return Object.fromEntries(
                    Object.keys(entryValues).map(key => {
                        if (!Array.isArray(entryValues[key])) {
                            return [key, loop(entryValues[key])];
                        } else {
                            let person = {};
                            entryValues[key].forEach(personData => {
                                person = {
                                    ...person,
                                    properties: personData.properties,
                                    [personData.sensingType]: personData.currentValue,
                                    targetId: personData.targetId,
                                    targetName: personData.targetName,
                                    targetNum: personData.targetNum,
                                    isBookmark: personData.isBookmark,
                                    modDate: personData.modDate,
                                    regDate: personData.regDate,
                                };
                            });
                            return [key, person];
                        }
                    }),
                );
            })(data);
        },
        initialWorkTimeList: (state, action) => {
            const workTimeList = action.payload.workTimeList;
            if (!workTimeList) {
                return;
            }

            // 서버에서 받은 최초 담당시간 현재시간 기준으로 생성
            const initWorkTimeList = workTimeList.map(item => {
                const { startDate, endDate } = item;
                // 서버로부터 받은 시작시간
                const responseStartDate = moment.unix(startDate);
                // 서버로부터 받은 종료시간
                const responseEndDate = moment.unix(endDate);
                // 현재 시작 시간
                let currentStartDate = moment()
                    .hours(responseStartDate.hours())
                    .minutes(responseStartDate.minutes())
                    .startOf('minutes');
                // 현재 종료 시간
                let currentEndDate = moment()
                    .hours(responseEndDate.hours())
                    .minutes(responseEndDate.minutes())
                    .endOf('minutes');
                // 시작 시간이 종료 시간보다 클 경우 D-1
                if (currentStartDate.hours() > currentEndDate.hours()) {
                    if (moment().isBetween(currentStartDate, moment().endOf('day'))) {
                        // 23:59:59 이전의 경우 end time 현재 시간으로 변경
                        currentEndDate = moment();
                    } else {
                        // 00시 이후 D-1
                        currentStartDate = currentStartDate.subtract(1, 'day');
                    }
                }
                return {
                    ...item,
                    startDate: currentStartDate.startOf('minutes').unix(),
                    endDate: currentEndDate.endOf('minutes').unix(),
                    valueOf: currentEndDate.unix() - currentStartDate.unix(),
                };
            });

            state.workTimeList = {
                origin: initWorkTimeList,
                current: convertToWorkTimeCheckList(initWorkTimeList), // 접속 시간에 따른 work time 시간 범위 수정
            };
        },
        resetCurrentWorkTime: state => {
            state.workTimeList = {
                ...state.workTimeList,
                current: convertToWorkTimeCheckList(state.workTimeList.origin),
            };
        },
        updateCurrentWorkTime: (state, action) => {
            const currentWorkTime = action.payload.currentWorkTime;
            if (!currentWorkTime) {
                return;
            }
            // 현재시간 업데이트
            const refreshCurrent = convertToWorkTimeCheckList(state.workTimeList.origin).map((item, idx) => ({
                ...item,
                checked: currentWorkTime[idx]?.checked,
            }));
            state.workTimeList = {
                ...state.workTimeList,
                current: refreshCurrent,
            };
        },
        setIsDetail: (state, action) => {
            state.isDetail = action.payload;
        },
        setTargetNum: (state, action) => {
            state.targetNum = action.payload;
        },
    },
});
export const {
    storeVitalSignList,
    initialWorkTimeList,
    resetCurrentWorkTime,
    updateCurrentWorkTime,
    setIsDetail,
    setTargetNum,
} = actions;
export default reducer;
